const config = {
  HOST_URL: 'https://api.ansice.td',
  HOST_API_URL: 'https://api.ansice.td/api',
  API_KEY:
    'Bearer 8920a31420b4f5b98c9cbcf1e46a8f44fcdda8486b1c7e77e1bbe488a176297b1d1b68ad49634ed333726b62ed45e0c43c6087c6cd37510488d50cc219b3643352af861eabaa428b33ebb021dcbaabb237a9ce8158ece342ad424fac809204366bc2147a2ed204aa4aadd3f726b2782bba092612551220902217985bc4ea9d34',
};

export default config;
